<panel width="600">
	<form>
		<h1>{{ 'company.domains.new-product-plan.headline' | translate }}</h1>
		<new-domain-product-plan-input [domainName]="domain?.name" />
		<section>
			<button ghost [ignoreValidation]="true" (click)="close()"><icon type="xmark" />{{ 'company.domains.new-product-plan.reject' | translate }}</button>
			<button confirm [active]="canConfirm()" (click)="confirm()"><icon type="plus" /> {{ 'company.domains.new-product-plan.confirm' | translate }}</button>
		</section>
	</form>
</panel>
